"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ELEVATION_LEVELS = exports.BOX_ALIGNMENTS = void 0;
const BOX_ALIGNMENTS = exports.BOX_ALIGNMENTS = ['start', 'center', 'end'];
const ELEVATION_LEVELS = exports.ELEVATION_LEVELS = ['base', 'card', 'raised', 'overlay', 'float'];